import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr'; 

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  c_p_hide: boolean = true;
  p_hide: boolean = true;
  enteremail: boolean = true;
  enterotp: boolean = false;
  errorMessage: string = '';
  changepassword: boolean = false;
  Email = new FormControl('', [
    Validators.required,
    Validators.email,
    Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
  ]);
  Password = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);
  ConfirmPassword = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);

  getEmailError() {
    if (this.Email.hasError('required')) {
      return 'Email is required.';
    } else if (this.Email.hasError('email')) {
      return 'Please enter a valid email address.';
    } else if (this.Email.hasError('pattern')) {
      return 'Email must have a valid domain (e.g., user@example.com).';
    } else {
      return '';
    }
  }

  getPasswordError() {
    if (this.Password.hasError('required')) {
      return 'Password is required.';
    }
    else if (this.Password.hasError('pattern')) {
      return 'Please enter a password more than 5 letters';
    }
    else {
      return '';
    }

  }
  getConfirmPasswordError() {
    if (this.ConfirmPassword.hasError('required')) {
      return 'Confirm Password is required.';
    }
    else if (this.ConfirmPassword.hasError('pattern')) {
      return 'Please enter Confirm password more than 5 letters';
    }
    else {
      return '';
    }
  }

  code: string[] = ['', '', '', ''];
  focusNext(event: KeyboardEvent, nextInputIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 0) {
      const nextInput = input.parentElement?.querySelector(`input:nth-child(${nextInputIndex + 1})`) as HTMLInputElement;
      nextInput?.focus();
    }
  }

  verifyCode(): void {
    const enteredCode = this.code.join(''); 

    if (!enteredCode || enteredCode.length !== 6) {
      this.showError('Enter Valid Code');
      return;
    }

    this.enteremail = false;
    this.enterotp = false;
    this.changepassword = true; 
    this.errorMessage = '';
    alert('Code: ' + enteredCode);
  }


  resendCode(): void {
  }

  constructor(private toastr: ToastrService) { }

  emailiscorrect() {
    if (this.Email.valid) {
      this.enteremail = false;
      this.enterotp = true;
      this.changepassword = false;
    } else {
      this.Email.markAsTouched(); 
    }
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error',
      timeOut: 2000,
      progressBar: true
    });
  }
  ngOnInit(): void{
  }
}
